import Config from '@/config'

const Helpers = {
	computed: {
		canAddOkResponse() {
			return (
				this.response &&
				[Config.RESPONSE_STATUS_WAIT].includes(this.response.status.id) &&
				this.responsesOkReceived < Config.DEFAULT_MAX_RESPONSES_OK
			)
		},
		canAddKoResponse() {
			return (
				this.response &&
				[Config.RESPONSE_STATUS_WAIT].includes(this.response.status.id) &&
				this.responsesKoReceived < Config.DEFAULT_MAX_RESPONSES_KO
			)
		},
		canViewSharedContacts() {
			/* return (
				this.response &&
				((this.isUserAccount &&
					[Config.RESPONSE_STATUS_OK, Config.RESPONSE_STATUS_APPROVED].includes(this.response.status.id)) ||
					(!this.isUserAccount &&
						this.response.shared_contacts &&
						[Config.RESPONSE_STATUS_OK, Config.RESPONSE_STATUS_APPROVED].includes(this.response.status.id)))
			) */
			return (
				this.response &&
				((!this.isUserAccount &&
					((this.response.shared_contacts &&
						this.response.request.shared_contacts &&
						[Config.RESPONSE_STATUS_OK, Config.RESPONSE_STATUS_APPROVED].includes(this.response.status.id)) ||
						(!this.response.shared_contacts && [Config.RESPONSE_STATUS_APPROVED].includes(this.response.status.id)))) ||
					(this.isUserAccount &&
						[Config.RESPONSE_STATUS_APPROVED].includes(this.response.status.id) &&
						[Config.REQUEST_STATUS_APPROVED].includes(this.response.request.status.id)))
			)
		},
		creditsCanBeRefunded() {
			// Get if credits can be refunded
			return (
				!this.isUserAccount &&
				this.credit &&
				[Config.CREDIT_TYPE_DEPOSIT].includes(this.credit.type.id) &&
				this.getRemainingDays(this.credit.created_at, Config.DEFAULT_REFUND_CREDITS_DAYS) > -1
			)
		},
		discountRequestIncentiveCanBeApplied() {
			// Discount available if a OK/KO response exists or request has at least 10 days
			return (
				1 === 0 &&
				this.request &&
				(Number(this.request.responses_counter.ok) +
					Number(this.request.responses_counter.approved) +
					Number(this.request.responses_counter.ko) >
					0 ||
					this.getRemainingDays(this.request.created_at, Config.DEFAULT_PREMIUM_REMIND_DAYS) <= -1)
			)
		},
		discountRequestPriceObject() {
			const priceToPayObject = { ...this.requestPriceObject }
			if (this.discountObject) {
				let discount = 0
				if (this.discountObject.type === Config.COUPONS_TYPE_DISCOUNT_PERCENTAGE) {
					// Discount by percentage
					discount = (priceToPayObject.price * this.discountObject.value) / 100
					priceToPayObject.price = priceToPayObject.price - discount
				} else if (this.discountObject.type === Config.COUPONS_TYPE_DISCOUNT_AMOUNT) {
					// Discount by removing an amount
					discount = this.discountObject.value
					priceToPayObject.price = priceToPayObject.price - discount
				} else if (this.discountObject.type === Config.COUPONS_TYPE_DISCOUNT_FIXED) {
					// Discount by applying a fixed price
					discount = priceToPayObject.price - this.discountObject.value
					priceToPayObject.price = this.discountObject.value
				} else {
					return null
				}

				// Round price
				priceToPayObject.price = Number(priceToPayObject.price.toFixed(2))

				// Set data
				priceToPayObject.priceString = priceToPayObject.price + ''
				priceToPayObject.priceLabel = priceToPayObject.price + ' €'
				priceToPayObject.discount = '-' + discount + ' €'
			} else {
				return null
			}
			return priceToPayObject
		},
		feedbackToBeManaged() {
			// Get if feedback has to be managed (only if no feedback has been inserted)
			return this.request && (this.request.feedback.updated === 0 || this.request.feedback.updated == false)
		},
		feedbackCanBeManaged() {
			// Get if feedback can to be managed (when a feedback has been already inserted)
			return this.request && this.request.feedback.updated === 1
		},
		isEnvDemo: function () {
			return process.env.DEMO_ENV
		},
		isFakeLawyer() {
			return (
				this.lawyer &&
				(this.lawyer === Config.DEFAULT_FAKE_LAWYER_ID ||
					(this.lawyer.id && this.lawyer.id === Config.DEFAULT_FAKE_LAWYER_ID))
			)
		},
		isFakeUser() {
			return (
				this.user &&
				(this.user === Config.DEFAULT_FAKE_USER_ID || (this.user.id && this.user.id === Config.DEFAULT_FAKE_USER_ID))
			)
		},
		isMessagesOpen() {
			return (
				this.response &&
				[
					Config.RESPONSE_STATUS_NEW,
					Config.RESPONSE_STATUS_PENDING,
					Config.RESPONSE_STATUS_WAIT,
					Config.RESPONSE_STATUS_OK,
				].includes(this.response.status.id) &&
				[Config.REQUEST_STATUS_NEW, Config.REQUEST_STATUS_WAIT].includes(this.response.request.status.id)
			)
		},
		isRequestApproved() {
			return this.request && [Config.REQUEST_STATUS_APPROVED].includes(this.request.status.id)
		},
		isRequestClosed() {
			return this.request && [Config.REQUEST_STATUS_CLOSED].includes(this.request.status.id)
		},
		isRequestInit() {
			return this.request && [Config.REQUEST_STATUS_INIT].includes(this.request.status.id)
		},
		isRequestIncomplete() {
			return this.request && [Config.REQUEST_STATUS_INCOMPLETE].includes(this.request.status.id)
		},
		isRequestInvalid() {
			return (
				this.request &&
				[Config.REQUEST_STATUS_INVALID_BY_DATA, Config.REQUEST_STATUS_INVALID_BY_OCCURRENCE].includes(
					this.request.status.id
				)
			)
		},
		isRequestOpen() {
			return this.request && [Config.REQUEST_STATUS_NEW, Config.REQUEST_STATUS_WAIT].includes(this.request.status.id)
		},
		isRequestNew() {
			return this.request && [Config.REQUEST_STATUS_NEW].includes(this.request.status.id)
		},
		isRequestRefunded() {
			return this.request && [Config.REQUEST_STATUS_REFUNDED].includes(this.request.status.id)
		},
		isRequestRejected() {
			return (
				this.request &&
				[
					Config.REQUEST_STATUS_REJECTED_1,
					Config.REQUEST_STATUS_REJECTED_2,
					Config.REQUEST_STATUS_REJECTED_3,
					Config.REQUEST_STATUS_REJECTED_WITH_REPLY,
				].includes(this.request.status.id)
			)
		},
		isRequestRetired() {
			return this.request && [Config.REQUEST_STATUS_RETIRED].includes(this.request.status.id)
		},
		isRequestWithSharedContacts() {
			return (this.request && this.request.shared_contacts) || (this.response && this.response.request.shared_contacts)
		},
		isResponseAccepted() {
			return this.response && [Config.RESPONSE_STATUS_OK].includes(this.response.status.id)
		},
		isResponseApproved() {
			return this.response && [Config.RESPONSE_STATUS_APPROVED].includes(this.response.status.id)
		},
		isResponseBlurred() {
			return (
				this.response &&
				[Config.RESPONSE_STATUS_PENDING].includes(this.response.status.id) &&
				[Config.REQUEST_PLAN_FREE, Config.REQUEST_PLAN_BASIC].includes(this.request.plan.id)
			)
		},
		isResponseClose() {
			return (
				this.response &&
				[Config.RESPONSE_STATUS_APPROVED, Config.RESPONSE_STATUS_OK, Config.RESPONSE_STATUS_KO].includes(
					this.response.status.id
				)
			)
		},
		isResponseDeclined() {
			return this.response && [Config.RESPONSE_STATUS_KO].includes(this.response.status.id)
		},
		isResponseForDemandant() {
			return this.response && [Config.REQUEST_PART_DEMANDANT].includes(this.response.request.part)
		},
		isResponseForRespondent() {
			return this.response && [Config.REQUEST_PART_RESPONDENT].includes(this.response.request.part)
		},
		isResponseOpen() {
			return (
				this.response &&
				[Config.RESPONSE_STATUS_NEW, Config.RESPONSE_STATUS_PENDING, Config.RESPONSE_STATUS_WAIT].includes(
					this.response.status.id
				)
			)
		},
		isResponseNew() {
			return this.response && [Config.RESPONSE_STATUS_NEW].includes(this.response.status.id)
		},
		isResponsePending() {
			return this.response && [Config.RESPONSE_STATUS_PENDING].includes(this.response.status.id)
		},
		isResponseWithSharedContacts() {
			return this.response && this.response.shared_contacts
		},
		messageType() {
			return this.isUserAccount ? Config.MESSAGE_FROM_USER : Config.MESSAGE_FROM_LAWYER
		},
		planBasic() {
			return Config.REQUEST_PLAN_BASIC
		},
		planFree() {
			return Config.REQUEST_PLAN_FREE
		},
		planPremium() {
			return Config.REQUEST_PLAN_PREMIUM
		},
		planTop() {
			return Config.REQUEST_PLAN_TOP
		},
		redirectTo() {
			return this.$route.query.redirect_to
		},
		requestCanBeApproved() {
			// Get if request can be approved (check if al least one OK response exists)
			return this.request && this.request.responses_counter && this.request.responses_counter.ok > 0
		},
		requestCanBeExtended() {
			// Get if request can be approved (managing approval extra time after request closing)
			return (
				this.request &&
				[Config.REQUEST_STATUS_CLOSED, Config.REQUEST_STATUS_WAIT].includes(this.request.status.id) &&
				this.getRemainingDays(
					this.request.created_at,
					Config.DEFAULT_DURATION_DAYS + Config.DEFAULT_EXTRA_APPROVAL_REQUEST_DAYS
				) > -1
			)
		},
		requestCanBeRefunded() {
			// Get if request can be refunded
			return (
				this.isUserAccount &&
				this.request &&
				[Config.REQUEST_STATUS_CLOSED].includes(this.request.status.id) &&
				[Config.REQUEST_PLAN_PREMIUM].includes(this.request.plan.id) &&
				this.request.responses_counter &&
				this.request.responses_counter.given === 0 &&
				this.getRemainingDays(this.request.created_at, Config.DEFAULT_REFUND_REQUEST_DAYS) > -1
			)
		},
		requestCanBeRetired() {
			// Get if request can be retired
			return (
				this.isUserAccount &&
				this.request &&
				[Config.REQUEST_STATUS_NEW, Config.REQUEST_STATUS_WAIT].includes(this.request.status.id) &&
				this.request.responses_counter &&
				this.request.responses_counter.given === 0
			)
		},
		requestCanBeUpgraded() {
			// Get if request can be updated
			return this.isUserAccount &&
				this.request &&
				[Config.REQUEST_PLAN_FREE, Config.REQUEST_PLAN_BASIC].includes(this.request.plan.id) &&
				[Config.REQUEST_STATUS_NEW, Config.REQUEST_STATUS_WAIT, Config.REQUEST_STATUS_CLOSED].includes(
					this.request.status.id
				) &&
				[
					'altre-risarcitorie',
					'cause-condominiali',
					'cause-di-lavoro',
					'contenziosi-commerciali',
					// 'contratti-assicurativi',
					// 'contenziosi-fiscali-e-tributari',
					'contratti-bancari-e-finanziari',
					'contratti-di-locazione',
					// 'danno-da-vacanza-rovinata',
					// 'diffamazione-a-mezzo-stampa',
					// 'divisioni-immobiliari,
					'lesioni-personali',
					'malasanita',
					'parte-civile-in-processi-penali',
					'recupero-crediti',
					// 'ricorsi-inps',
					'sinistri-stradali',
					'successioni-ereditarie',
				].indexOf(this.request.request_type.id) !== -1
				? true
				: false
		},
		requestPriceObject() {
			if (this.$store.state.misc.plan === Config.REQUEST_PLAN_BASIC) {
				// Basic plan
				return this.paypalBasicRequestData[0]
			} else if (this.$store.state.misc.plan === Config.REQUEST_PLAN_PREMIUM) {
				// Premium plan
				return this.paypalPremiumRequestData[0]
			} else {
				// Upgrade to Premium
				return this.paypalUpgradeToPremiumRequestData[0]
			}
		},
		requestsDone() {
			return this.$store.getters.requests && this.$store.getters.requests.length > 0
				? this.$store.getters.requests.length
				: 0
		},
		requestsPending() {
			let requestsCounter = 0

			// Loop over requests
			Object.values(this.$store.getters.requests).forEach((request) => {
				// Check current request for filtering only pending responses
				if (request !== undefined && request.status.id === Config.REQUEST_STATUS_WAIT) {
					requestsCounter = requestsCounter + 1
				}
			})

			return requestsCounter
		},
		requestStatus() {
			// Get request status
			if (this.request.status.id === Config.REQUEST_STATUS_APPROVED) {
				return 'approved'
			} else if (this.request.status.id === Config.REQUEST_STATUS_REFUNDED) {
				return 'refunded'
			} else if (this.request.status.id === Config.REQUEST_STATUS_RETIRED) {
				return 'retired'
			} else if (this.request.status.id === Config.REQUEST_STATUS_CLOSED) {
				return 'closed'
			} else if (this.request.status.id === Config.REQUEST_STATUS_INCOMPLETE) {
				return 'incomplete'
			} else if (this.request.status.id === Config.REQUEST_STATUS_NEW) {
				return 'new'
			} else if (this.request.status.id === Config.REQUEST_STATUS_INIT) {
				return 'init'
			} else if (
				this.request.status.id === Config.REQUEST_STATUS_INVALID_BY_DATA ||
				this.request.status.id === Config.REQUEST_STATUS_INVALID_BY_OCCURRENCE
			) {
				return 'invalid'
			} else if (
				this.request.status.id === Config.REQUEST_STATUS_REJECTED_1 ||
				this.request.status.id === Config.REQUEST_STATUS_REJECTED_2 ||
				this.request.status.id === Config.REQUEST_STATUS_REJECTED_3 ||
				this.request.status.id === Config.REQUEST_STATUS_REJECTED_WITH_REPLY
			) {
				return 'rejected'
			} else {
				return 'open'
			}
		},
		requiredMark() {
			// If rules contains "required", show "required" mark beside label
			if ((this.rules && typeof this.rules === 'object') || this.forceRequiredMark) {
				return this.rules.required || this.forceRequiredMark ? '*' : ''
			} else {
				return this.rules && this.rules.includes('required') ? '*' : ''
			}
		},
		responsesApproved() {
			let responsesCounter = 0

			// Loop over requests
			Object.values(this.$store.getters.requests).forEach((request) => {
				// Loop over responses
				Object.values(request.responses).forEach((response) => {
					// Check current response for filtering only approved responses
					if (response !== undefined && response.status.id === Config.RESPONSE_STATUS_APPROVED) {
						responsesCounter = responsesCounter + 1
					}
				})
			})

			return responsesCounter
		},
		responsesOkReceived() {
			if (this.response && this.response.request && this.response.request.responses_counter) {
				return this.response.request.responses_counter.ok + this.response.request.responses_counter.approved
			} else {
				return 0
			}
		},
		responsesKoReceived() {
			if (this.response && this.response.request && this.response.request.responses_counter) {
				return this.response.request.responses_counter.ko
			} else {
				return 0
			}
		},
		responsesContactsAcquired() {
			if (this.response && this.response.request && this.response.request.responses_counter) {
				return this.response.request.responses_counter.contacts
			} else {
				return 0
			}
		},
		showLabel() {
			// If "label" prop is provided, show it
			return this.label !== ''
		},
	},
	methods: {
		between: function (value, min, max, lowerBound, upperBound) {
			if (lowerBound && !upperBound) {
				return value >= min && value < max
			} else if (!lowerBound && upperBound) {
				return value > min && value <= max
			} else if (!lowerBound && !upperBound) {
				return value > min && value < max
			} else {
				return value >= min && value <= max
			}
		},
		capitalize: function (value) {
			return value.charAt(0).toUpperCase() + value.slice(1)
		},
		decodeRequestPlan(value) {
			if (value === Config.REQUEST_PLAN_FREE) {
				return this.$t('Misc.Free')
			} else if (value === Config.REQUEST_PLAN_BASIC) {
				return this.$t('Misc.Basic')
			} else if (value === Config.REQUEST_PLAN_PREMIUM) {
				return this.$t('Misc.Premium')
			} else {
				return '-'
			}
		},
		decodeRequestPart(value) {
			if (!value) {
				return '-'
			}
			return value === Config.REQUEST_PART_DEMANDANT ? this.$t('Misc.PartDemandant') : this.$t('Misc.PartRespondent')
		},
		decodeRequestType(value) {
			return value ? this.$t('Page.Title.RequestTypesDetail.' + value) : '-'
		},
		distance: function (lat1, lon1, lat2, lon2, unit = 'K') {
			/*
			Params:
			lat1, lon1 = Latitude and Longitude of point 1 (in decimal degrees)
			lat2, lon2 = Latitude and Longitude of point 2 (in decimal degrees)
			unit = the unit you desire for results
				- 'M' is statute miles
				- 'K' is kilometers (default)
				- 'N' is nautical miles
			*/
			if (lat1 == lat2 && lon1 == lon2) {
				return 0
			} else {
				const radLat1 = (Math.PI * lat1) / 180
				const radLat2 = (Math.PI * lat2) / 180
				const theta = lon1 - lon2
				const radTheta = (Math.PI * theta) / 180
				let dist = Math.sin(radLat1) * Math.sin(radLat2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.cos(radTheta)
				if (dist > 1) {
					dist = 1
				}
				dist = Math.acos(dist)
				dist = (dist * 180) / Math.PI
				dist = dist * 60 * 1.1515 * 1.609344
				if (unit == 'M') {
					dist = (dist / 1.609344).toFixed(2) + 'M'
				} else if (unit == 'N') {
					dist = (dist * 0.8684).toFixed(2) + 'N'
				} else {
					dist = dist.toFixed(2) + 'Km'
				}
				return dist
			}
		},
		getRemainingDays: function (date, durationDays = Config.DEFAULT_DURATION_DAYS) {
			// Find the remaining days between now and a duration days period (calculated from a provided date)
			const remainingDays = this.$moment.duration(this.$moment().diff(date)).asDays()
			return durationDays - Math.ceil(remainingDays)
		},
		isDesktop() {
			if (!this.isMobile() && !this.isTablet()) {
				return true
			} else {
				return false
			}
		},
		isMobile() {
			if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				return true
			} else {
				return false
			}
		},
		isTablet() {
			if (/iPad/i.test(navigator.userAgent)) {
				return true
			} else {
				return false
			}
		},
		normalizeArrayById: function (array) {
			// Convert an object array to an simple array (of IDs)
			return array.map(function (item) {
				return item.id
			})
		},
		nvl(value, placeholder = '-') {
			return value != '' && value != undefined ? value : placeholder
		},
	},
}

export default Helpers



// WEBPACK FOOTER //
// ./src/mixins/Helpers.js